module.exports = __webpack_public_path__ + "static/voucher-c00256800423f88f7ff7f267282794d1.svg";